module.exports = __webpack_public_path__ + "img/a19cf.39ee3056.png";